// extracted by mini-css-extract-plugin
module.exports = {"employees":"Service_employees__2jNlC","employeeSection":"Service_employeeSection__2MZSp","principal":"Service_principal__3yNGr"};